// Keep in sync with experimental.serverActions.bodySizeLimit ('4mb') in apps/thesiadgroup/next.config.js
export const MAX_UPLOAD_FILE_SIZE_BYTES = 4 * 1024 * 1024
